import { accessNilAssistDashboard, accessServiceProvidersDashboard, accessUploadTransactions } from '@/permissions/nil';
import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
	{
		path: '/upload-transactions',
		name: 'UploadTransactions',
		component: () => import('@/views/UploadTransactions.vue'),
		meta: {
			layout: 'LayoutAuthenticated',
			requiresAuth: true,
			title: 'pageUploadTransactions.metaTitle',
			permissionRule: accessUploadTransactions,
		},
	},
	{
		path: '/dashboards',
		name: 'ComplianceDashboards',
		component: () => import('@/views/ComplianceDashboards.vue'),
		redirect: { name: 'NilAssistDashboard' },
		children: [
			{
				path: 'nil-assist-dashboard',
				name: 'NilAssistDashboard',
				component: () => import('@/views/NilAssistDashboard.vue'),
				meta: {
					layout: 'LayoutAuthenticated',
					requiresAuth: true,
					title: 'pageNilAssistDashboard.metaTitle',
					permissionRule: accessNilAssistDashboard,
				},
			},
			{
				path: 'ncaa-service-providers',
				name: 'ServiceProvidersDashboard',
				component: () => import('@/views/ServiceProvidersDashboard.vue'),
				meta: {
					layout: 'LayoutAuthenticated',
					requiresAuth: true,
					title: 'pageServiceProvidersDashboard.metaTitle',
					permissionRule: accessServiceProvidersDashboard,
				},
			},
		],
	},
	{
		path: '/:username',
		name: 'AthletePublicProfile',
		component: () => import('@/views/AthletePublicProfile.vue'),
		props: true,
		meta: {
			layout: 'LayoutDefault',
			requiresAuth: false,
			title: 'pageAthletePublicProfile.metaTitle',
		},
	},
];

export default routes;
